// What a department document may be, and how the viewer shows each kind.

// Mirrors the createUploader call in apps/server/src/routes/departmentDocumentRoutes.js
// (same list as protocols). Offering less hides usable formats; offering more
// fails the whole upload on one rejected file.
export const DOCUMENT_ACCEPT = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'text/csv': ['.csv'],
  'text/plain': ['.txt'],
  'application/rtf': ['.rtf'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  'image/gif': ['.gif'],
  'image/bmp': ['.bmp'],
  'image/tiff': ['.tif', '.tiff'],
  'video/mp4': ['.mp4'],
  'video/quicktime': ['.mov'],
  'video/x-msvideo': ['.avi'],
  'message/rfc822': ['.eml'],
  'application/vnd.ms-outlook': ['.msg'],
};

export const DOCUMENT_MAX_SIZE = 20 * 1024 * 1024;
export const DOCUMENT_MAX_FILES = 20;

export const extensionOf = (fileName) => {
  const dot = (fileName || '').lastIndexOf('.');
  return dot > 0 ? fileName.slice(dot + 1).toLowerCase() : '';
};

const VIEWERS = {
  pdf: 'pdf',
  png: 'image', jpg: 'image', jpeg: 'image', gif: 'image', webp: 'image', bmp: 'image',
  mp4: 'video', mov: 'video',
  docx: 'docx',
  pptx: 'pptx',
  xlsx: 'sheet', xls: 'sheet', csv: 'sheet',
  txt: 'text',
};

/**
 * Which in-page viewer can show this file, or 'none' when it can only be
 * downloaded (legacy .doc / .ppt, .rtf, mail, TIFF, AVI).
 */
export const viewerKindOf = (fileName) => VIEWERS[extensionOf(fileName)] || 'none';
